import { useMemo, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function SearchSelect({ items, value, onChange, placeholder = "Select…", getLabel = (i) => i.name, getSub, testId = "search-select", disabled }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const selected = items?.find((i) => i.id === value);
  const filtered = useMemo(() => (items || []).filter((i) => (getLabel(i) + " " + (getSub ? getSub(i) : "")).toLowerCase().includes(q.toLowerCase())).slice(0, 50), [items, q, getLabel, getSub]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" disabled={disabled} className="w-full justify-between font-normal" data-testid={testId}>
          <span className="truncate">{selected ? getLabel(selected) : <span className="text-slate-400">{placeholder}</span>}</span><ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] bg-white p-2" align="start">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Type to search…" className="mb-2 h-8" autoFocus data-testid={`${testId}-search`} />
        <div className="max-h-60 overflow-y-auto">
          {filtered.length === 0 && <div className="px-2 py-3 text-xs text-slate-500">No matches</div>}
          {filtered.map((i) => (
            <button key={i.id} type="button" onClick={() => { onChange(i.id, i); setOpen(false); setQ(""); }} data-testid={`${testId}-option-${i.id}`}
              className="flex w-full items-center justify-between rounded px-2 py-1.5 text-left text-sm hover:bg-blue-50">
              <span><span className="block">{getLabel(i)}</span>{getSub && <span className="block text-[11px] text-slate-500">{getSub(i)}</span>}</span>
              {i.id === value && <Check className="h-4 w-4 text-blue-600" />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
